module.exports = __webpack_public_path__ + "img/34.72003b5d.jpg";